import {
  IBaseAppConfig,
  IDegradationConfig,
  IGlobalConfig,
  ITenantAppConfig
} from '../providers/types';

export const getAppConfig = (function() {
  const { tenantAppConfig = {} } = window;
  let appConfig: IBaseAppConfig;
  // cleanup
  // delete window.tenantAppConfig;

  return function<T extends IBaseAppConfig>(
    tenantName: string
  ): ITenantAppConfig<T> {
    if (!appConfig) {
      appConfig = { ...tenantAppConfig[tenantName], ...tenantAppConfig.global };
    }
    return appConfig as ITenantAppConfig<T>;
  };
})();

interface ITenantDegradationConfig {
  tenant: string;
  degradationConfig: IDegradationConfig;
}

export const getTenantDegradationConfig = (function() {
  let tenantDegradationConfig: ITenantDegradationConfig | null;
  const { tenantAppConfig } = window;
  return function(): ITenantDegradationConfig | null {
    if (tenantDegradationConfig) {
      return tenantDegradationConfig;
    }
    const globalConfig = tenantAppConfig?.global as IGlobalConfig;
    const { degradation } = globalConfig ?? {};
    if (degradation) {
      for (const [tenant, degradationConfig] of Object.entries(degradation)) {
        const { identifier } = degradationConfig;
        if (window.location.pathname.startsWith(identifier)) {
          tenantDegradationConfig = {
            tenant,
            degradationConfig
          };
          return tenantDegradationConfig;
        }
      }
    }
    return null;
  };
})();

export const showDegradedExperience = () => {
  const tenantDegradationConfig = getTenantDegradationConfig();
  if (tenantDegradationConfig) {
    const { degradationConfig, tenant } = tenantDegradationConfig;
    try {
      const url = new URL(
        degradationConfig.degradedUrl,
        window.location.origin
      );
      url.searchParams.set('sourceTenant', tenant);
      window.location.href = url.toString();
    } catch (error) {
      console.error('Invalid degradation url');
    }
  }
};

export const shouldTurnOffTenant = () => {
  const tenantDegradationConfig = getTenantDegradationConfig();
  if (tenantDegradationConfig) {
    const {
      degradationConfig: { turnOff, skipPaths }
    } = tenantDegradationConfig;
    return (
      turnOff &&
      !skipPaths.some(skipPath =>
        new RegExp(skipPath).test(window.location.pathname)
      )
    );
  }
  return false;
};
